.page {
  padding: var(--space-4, 1rem);
  max-width: 48rem;
  margin: 0 auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.createLink {
  font-size: var(--text-min-body, 0.875rem);
}

.tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tab {
  background: none;
  border: 1px solid var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 0.35rem 0.75rem;
  cursor: pointer;
}

.tab[data-active='true'] {
  background: var(--card);
  border-color: var(--ink-soft);
  font-weight: 600;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.card {
  background: var(--card);
  border: 1px solid var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 1rem;
}

.sender {
  font-family: var(--font-mono);
  font-weight: 600;
  margin: 0;
}

.message {
  margin: 0.35rem 0;
}

.meta {
  font-size: var(--text-min-body, 0.875rem);
  color: var(--muted);
  margin: 0.15rem 0;
}

.peerActions {
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 0.75rem;
}

/*
 * `SPEC-ONB-001 §2`. Deliberately below the two peer actions, behind a
 * toggle — not a third button beside "Accept and name"/"Reject". Its own
 * warning color marks it as the weightier path once opened.
 */
.mergeToggle {
  display: block;
  margin-top: 0.75rem;
  background: none;
  border: none;
  color: var(--warn);
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}

.mergeFlow {
  margin-top: 0.75rem;
  padding: 0.75rem;
  border: 1px solid var(--warn);
  border-radius: var(--radius-soft);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mergeWarning {
  margin: 0;
  font-size: var(--text-min-body, 0.875rem);
  color: var(--stop);
}

.otpRow {
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
}

.error {
  color: var(--stop);
  font-size: var(--text-min-body, 0.875rem);
  margin: 0;
}

.status {
  color: var(--muted);
  margin: 0.5rem 0 0;
}

.empty {
  color: var(--muted);
}
